import {
  getAlarmProfiles,
  getAlarmProfilesReferenceCopy,
} from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { putAlarmProfilesUseCase } from "@src/cloud-connect/alarms/use-cases/put-alarm-profiles-use-case";

type FetchErrorBody = {
  detail?: unknown;
  message?: string;
};

type DetailItem = {
  message?: string;
  msg?: string;
};

const getFetchErrorMessage = (
  body: FetchErrorBody | undefined,
  fallbackMessage: string,
) => {
  if (Array.isArray(body?.detail) && body.detail.length > 0) {
    const firstDetail = body.detail[0] as DetailItem | undefined;
    return firstDetail?.msg || firstDetail?.message || fallbackMessage;
  }

  return body?.message || fallbackMessage;
};

const writeCurrentAlarmProfilesOnReferenceAlarmProfiles = () => {
  const currentAlarmProfiles = getAlarmProfiles();
  const alarmProfilesReferenceCopy = getAlarmProfilesReferenceCopy();

  const clonedAlarmProfiles = currentAlarmProfiles.clone();

  alarmProfilesReferenceCopy.setAlarmProfiles(
    clonedAlarmProfiles.getAlarmProfiles(),
  );
};

export const transferAlarmProfilesToClientUseCase = async (
  setButtonLoading?: (loading: boolean) => void,
) => {
  setButtonLoading && setButtonLoading(true);
  const response = await putAlarmProfilesUseCase(getAlarmProfiles().toJSON());
  if (response && response.success && response.status === 200) {
    //this is needed to write the current alarm profiles on the reference copy

    writeCurrentAlarmProfilesOnReferenceAlarmProfiles();
    successSnackbar("Condition Monitoring settings saved successfully", 3000);
  } else if (response && (response.status === 401 || response.status === 422)) {
    const message = getFetchErrorMessage(
      response.body,
      "Failed to save alarm settings",
    );
    errorSnackbar(
      `Failed to save alarm settings: Error ${response.status} - ${message}`,
      5000,
    );
  } else {
    errorSnackbar("Failed to save alarm settings", 5000);
  }

  setButtonLoading && setButtonLoading(false);
};
